<template>
  <div>
    <div align="center">
      <div
        class="Flex_Table"
        style="border: 1px solid black; width: 40%; font-size: 16px"
      >
        <div class="Flex_Row" style="text-align: center">
          <div class="Flex_Cell">
            <h2>Transaction Status</h2>
            <hr />
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left">
          <div class="Flex_Cell" style="width: 40%">
            <span>Transaction Ref No.</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ transRefNo }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left">
          <div class="Flex_Cell" style="width: 40%">
            <span>Amount</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ paymentAmount }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left">
          <div class="Flex_Cell" style="width: 40%">
            <span>Transaction Date & Time</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ tranDate }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left">
          <div class="Flex_Cell" style="width: 40%">
            <span>Transaction Status</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span :class="transStatus">{{ transStatus }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left">
          <div class="Flex_Cell" style="width: 40%">
            <span>Status Description</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span :class="transStatus">{{ statusDesc }}</span>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div align="center">
      <p>*Please noted the transaction ref number for future reference</p>
    </div>
    <br />
    <div align="center">
      <span style="width: 160px"></span>
      <input
        type="button"
        v-on:click="redirectToForm()"
        value="Redirect to Main Form"
      />
      <input
        type="button"
        value="Print Receipt"
        @click="GetPaymentReceipt(1)"
        v-if="isSuccess"
      />
    </div>
    <div
      v-if="isSuccess"
      style="color: red; margin-top: 10px; text-align: center"
    >
      <img style="height: 150px" src="../assets/images/paysuccess.gif" />
    </div>
    <div
      v-if="!isSuccess"
      style="color: red; margin-top: 10px; text-align: center"
    >
      <img style="height: 150px" src="../assets/images/payerror.gif" />
    </div>
    <div v-if="isSuccess" align="center">
      <br />
      <h1 style="color: green">
        Your Application Form is Submitted Successully !!
      </h1>
    </div>
    <img src="../assets/images/header.png" style="display: none" id="header" />
    <img
      src="../assets/images/nibm-water-mark.jpg"
      style="display: none"
      id="bg"
    />
  </div>
</template>
<style scoped>
.Success {
  color: green;
}
.Failed {
  color: red;
}
</style>
<script>
import PaymentJS from "./serviceJS/paymentJS.js";
export default {
  name: "TransSuccess",
  data() {
    return {
      transRefNo: "",
      paymentAmount: "",
      tranDate: "",
      transStatus: "",
      statusDesc: "",
      isSuccess: false,
      NomAuthID: -1,
    };
  },
  methods: {
    getdata() {
      const _data_ = { NomAuthID: this.NomAuthID };
      PaymentJS.TransSuccess(_data_).then(
        (response) => {
          // console.log(response.data.result);
          if (response.data.isSuccess) {
            this.transRefNo = response.data.result.bankTxnID;
            this.paymentAmount = response.data.result.amount;
            this.tranDate = response.data.result.txnDate;
            this.transStatus = response.data.result.txnStatus;
            this.statusDesc = response.data.result.txnStatusDesc;
            this.isSuccess =
              response.data.result.txnStatusID == 1 ? true : false;
            //this.isSuccess = true;
          } else {
            alert(response.data.msg);
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    printData(_html) {
      this.windowPreview;
      if (this.windowPreview != null) {
        this.windowPreview.close();
      }
      this.windowPreview = window.open(
        "",
        "FilePreview",
        "scrollbars,addressbar=no,location=no, resizable=yes,width=900px,height=700px,left=10,top=10"
      );
      this.windowPreview.document.write(_html);
    },
    GetPaymentReceipt(type) {
      const _data_ = {
        NomineeID: this.NomAuthID,
        Type: type,
      };
      PaymentJS.GetPaymentReceipt(_data_).then(
        (response) => {
          if (response.data.isSuccess) {
            var tbl1 = response.data.result[0];
            var tbl2 = response.data.result1[0];
            var tbl3 = response.data.result2[0];
            var amountInWords = response.data.result3;
            let _html = "";

            _html = this.printPaymentReceipt(tbl1, tbl2, tbl3, amountInWords);
            if (_html != "") {
              this.printData(_html);
              // alert(this.numberToWords(412));
            }
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
    printPaymentReceipt(tbl1, tbl2, tbl3, amountInWords) {
      var _html = "";
      _html = "<html><body>";
      _html += "<style>";
      _html += "@media print";
      _html += "{";
      _html += "body * ";
      _html += "{";
      _html += "visibility: hidden;";
      _html += "}";
      _html += "#printSection,";
      _html += "#printSection * ";
      _html += "{";
      _html += "visibility: visible;";
      _html += "width: 100%;";
      _html += "}";
      _html += "#printSection {";
      _html += "position: relative;";
      _html += "padding: 0px 0px 0px 0px !important;";
      _html += "}";
      _html += "}";
      _html += "font ";
      _html += "{font-size:8pt;";
      _html += "}";
      _html += "DIV.pageClass";
      _html += "{";
      _html += "margin-left: auto;";
      _html += "font-family: Calibri;";
      _html += "padding-top: 20px;";
      _html += "padding-bottom: 20px;";
      _html += "margin-right: auto;";
      _html += "border: 1px solid black;";
      _html += "}";
      _html += "TABLE.BoxDesign TR";
      _html += "{";
      _html += "height: 21px;";
      _html += "}";
      _html += "TABLE.BoxDesign TD";
      _html += "{";
      _html += "BORDER-RIGHT: gray 1px solid;";
      _html += "BORDER-BOTTOM: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "padding-left: 5px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.BoxDesign";
      _html += "{";
      _html += "BORDER-TOP: gray 1px solid;";
      _html += "BORDER-LEFT: gray 1px solid;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TR";
      _html += "{";
      _html += "height: 15px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.FormDesign TD";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "font-size:15px;";
      _html += "padding-left: 2px;";
      _html += "overflow-wrap: anywhere;";
      _html += "}";
      _html += "TABLE.FormDesign";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .5px solid;";
      _html += "}";
      _html += "TABLE.RoleDesign TR";
      _html += "{";
      _html += "height: 16px;";
      _html += "border-collapse: collapse;";
      _html += "}";
      _html += "TABLE.RoleDesign TD";
      _html += "{";
      _html += "text-align: center;";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "font-size:small;";
      _html += "padding-left: .1px;";
      _html += "overflow-wrap: anywhere;";
      _html += "padding: 4px 10px 4px 10px;";
      _html += "}";
      _html += "TABLE.RoleDesign";
      _html += "{";
      _html += "border-collapse: collapse;";
      _html += "BORDER: gray .1px solid;";
      _html += "margin: 20px;";
      _html += "}";
      _html += "P.Page_Break";
      _html += "{";
      _html += "PAGE-BREAK-BEFORE: always;";
      _html += "border-color: gray !important;";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "a.PRINTBTN";
      _html += "{";
      _html +=
        "background-color: #488bda !important;padding: 5px 20px 5px 20px;";
      _html += "color: white;border-radius:5px;";
      _html += "background-image: none;";
      _html += "cursor:pointer";
      _html += "}";
      _html += "a.PRINTBTN:hover";
      _html += "{";
      _html += "background-color: rgba(255, 255, 255, 0.2);";
      _html += "}";
      _html += "a.PRINTBTN";
      _html += "{";
      _html +=
        "background-color: #488bda !important;padding: 5px 20px 5px 20px;";
      _html += "color: white;border-radius:5px;";
      _html += "background-image: none;";
      _html += "cursor:pointer";
      _html += "}";
      _html += "</style>";
      _html +=
        "<div align='center' style='width:100%;padding: 5px 0px 15px 10px;'>";
      _html +=
        "<a style='width: 100%;' onclick='window.print();return false;' class='PRINTBTN glyphicons print' >";
      _html += "Print";
      _html += "</a>";
      _html += "</div>";
      _html +=
        "<div class='pageClass bgClass' id='printSection' align='center' style='width:850px'>";
      var bgImg = document.createElement("img");
      var bgnewImg = document.getElementById("bg");
      bgImg.src = bgnewImg.src;
      _html +=
        "<img style='z-index: -1;position: absolute;left: 0;width: 850px;height:100%;right: 0;' src='" +
        bgImg.src +
        "'/>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 15px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td align='left' style='width: 100%'>";
      let newImg = document.createElement("img");
      newImg.style.height = "100px";
      newImg.src = document.getElementById("header").src;
      _html += newImg.outerHTML;
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr style='border-top: solid 1px;border-bottom: solid 1px;'>";
      _html += "<td style='width: 100%'>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 20px'>";
      _html += "<b>RECEIPT</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 100%'>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 16px'>";
      _html += "<b>" + tbl1.forProgramme + "</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 100%; margin-top:3px; padding: 0px 20px 0px 20px;'>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 9%'>";
      _html += "<b>Ref. No.</b>";
      _html += "</td>";
      _html += "<td style='width: 1%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 26%'>" + tbl1.nominationCode;
      _html += "</td>";
      _html += "<td style='width: 10%'>";
      _html += "<b>Receipt No.</b>";
      _html += "</td>";
      _html += "<td style='width: 1%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 26%'>";
      _html += tbl3.receiptNo;
      _html += "</td>";
      _html += "<td style='width: 11%'>";
      _html += "<b>Receipt Date</b>";
      _html += "</td>";
      _html += "<td style='width: 1%'>";
      _html += "<b>:</b>";
      _html += "</td>";
      _html += "<td style='width: 10%'>";
      _html += new Date(tbl3.paymentDate).convertToString("dd/MM/yyyy");
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr>";
      _html += "<td style='width: 100%;padding:19px'>";
      _html +=
        "<span style='color: #054889;font-size: 16px;text-decoration:justify'>";
      _html +=
        "<b>Received with thanks from <span style='text-transform: uppercase;'>" +
        tbl1.nomineeName +
        "</span> the sum of Rupees <span style='text-transform: uppercase;'>" +
        //commonJS.numberToWords(tbl3.paymentAmount) +
        amountInWords +
        "</span> for the " +
        tbl2.feeHeadName +
        " for the Programme " +
        tbl1.forProgramme +
        " as per following details:</b>";
      _html += "</span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 97%; margin-top:3px; padding: 0px 20px 0px 20px;' class='RoleDesign'>";
      _html += "<tbody>";
      _html += "<tr style='background-color:lightgrey;'>";
      _html += "<td style='width: 10%; text-align: left;'>";
      _html += "<b>Sr.No.</b>";
      _html += "</td>";
      _html += "<td style='width: 60%; text-align: left;'>";
      _html += "<b>Particulars</b>";
      _html += "</td>";
      _html += "<td style='width: 30%; text-align: right;'>";
      _html += "<b>Amount in ";
      if (tbl2.currency == "1") {
        _html += "&#x20B9;</b>";
      } else if (tbl2.currency == "2") {
        _html += "&#36;</b>";
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 10%; text-align: left;'>";
      _html += tbl2.srNo;
      _html += "</td>";
      _html += "<td style='width: 60%; text-align: left;'>";
      _html += tbl2.feeHeadName;
      _html += "</td>";
      _html += "<td style='width: 30%; text-align: right;'>";
      _html += tbl2.feeAmount;
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 10%; text-align: left;'>";
      _html += "</td>";
      _html += "<td style='width: 60%; text-align: right;'>";
      _html += "<b>Total</b>";
      _html += "</td>";
      _html += "<td style='width: 30%; text-align: right;'><b>";
      _html += tbl2.feeAmount;
      _html += "</b></td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table><br/><br/><br/>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr style='border-top:solid 1px;'>";
      _html += "<td style='width: 100%'>";
      _html += "<center>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html += "<b>DETAILS OF PAYMENT MADE TOWARDS FEES</b>";
      _html += "</span>";
      _html += "</center>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html +=
        "<table style='width: 97%; margin-top:3px; padding: 0px 20px 0px 20px;' class='RoleDesign'>";
      _html += "<tbody>";
      _html += "<tr style='background-color:lightgrey;'>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += "<b>Payment Mode</b>";
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += "<b>Transaction ID</b>";
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += "<b>Transaction Date</b>";
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: right;'>";
      _html += "<b>Amount in ";
      if (tbl2.currency == "1") {
        _html += "&#x20B9;</b>";
      } else if (tbl2.currency == "2") {
        _html += "&#36;</b>";
      }
      _html += "</td>";
      _html += "</tr>";
      _html += "<tr>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += tbl3.paymentMode;
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += tbl3.gatewayTransactionID;
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: left;'>";
      _html += new Date(tbl3.paymentDate).convertToString("dd/MM/yyyy");
      _html += "</td>";
      _html += "<td style='width: 20%; text-align: right;'>";
      _html += tbl3.paymentAmount;
      _html += "</td>";
      _html += "</tbody>";
      _html += "</table><br/><br/><br/><br/><br/>";
      _html += "<table>";
      _html += "<tbody>";
      _html += "<tr >";
      _html += "<td style='width: 100%'>";
      _html += "<span style='color: #054889;font-size: 18px'>";
      _html +=
        "<b>AMOUNT IN WORDS : </b><span style='text-transform: uppercase;'>";
      _html += amountInWords; //commonJS.numberToWords(tbl3.paymentAmount);
      _html += "</span></span>";
      _html += "</td>";
      _html += "</tr>";
      _html += "</tbody>";
      _html += "</table>";
      _html += "</div>";
      _html += "</body>";
      _html += "</html>";
      return _html;
    },
    redirectToForm() {
      this.$router.push({ name: "Application" });
    },
    // printReceipt: function () {
    //   this.startMsg = "Please wait for report generation";
    //   var basicData = {
    //     CandidateID: -1,
    //     AppNo: this.applicationNo,
    //     Type: 1,
    //     FileName: "Payment Receipt",
    //     FileFormat: "PDF",
    //     FileExtension: "pdf",
    //   };
    //   const _data_ = {
    //     candidateID: -1,
    //     type: 1,
    //   };
    //   ApplicationJS.PrintReceipt(_data_).then(
    //     (response) => {
    //       this.reportPOPUp(response.data, basicData.FileExtension.toString());
    //     },
    //     (error) => {
    //       if (error.response == undefined) {
    //         alert("Error: " + error);
    //       } else {
    //         alert("Error: " + error.response.statusText);
    //       }
    //     },
    //     (failure) => {
    //       alert("Failure: " + failure);
    //     }
    //   );
    // },
    reportPOPUp(data, ext) {
      var arg = data.split("|");
      if (arg[0] == "TRUE") {
        var base64Data = this.b64toBlob(arg[2]);
        if (window.saveAs) {
          window.saveAs(base64Data, fileName);
        } else if (navigator.SaveBlob) {
          navigator.SaveBlob(base64Data, fileName);
        } else if (navigator.msSaveBlob) {
          // For IE
          navigator.msSaveBlob(base64Data, fileName);
          this.startMsg = "Report generated";
        } else {
          // FOR FireFox & G Crome
          var fileName = arg[1];
          var linkSource = "data:application/" + ext + ";base64," + arg[2];
          var downloadLink = document.createElement("a");
          document.body.appendChild(downloadLink);
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.startMsg = "Report generated";
        }
      } else {
        alert(arg[1]);
      }
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  mounted() {
    let me = this;
    me.NomAuthID = me.$route.query.nomauthid;
    me.getdata();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TransSuccess.vue